import React from 'react';

import Popup from '../../Popup';
import Img from '../../Img';

import styles from './ncsaPopup.scss';
import { getClickAttrs } from '../../Analytics/gtag';

const NCSAPopup = (props) => {
    const {
        onConfirm,
        onCloseClick,
    } = props;

    return (
        <Popup
            className={`popup-md`}
            popUpClassName={`${styles.welcomePopUp}`}
            onCloseClick={onCloseClick}
            config={{
                noPadding: true,
                fullScreen: false,
                topGradient: false,
                scrollable: false,
            }}
            data-testid="modal.ncsa"
        >
            <div className={`${styles.section} pt0 pb24`}>
                <h5 data-testid="modal.ncsa.title">Are you interested in playing college tennis?</h5>
            </div>
            <div className={`${styles.section} ${styles.images} p0`}>
                <Img
                    src="/img/utr_sports/utr-sports-logo.svg"
                    className={`${styles.utrlogo} align-self-start`}
                />
                <span className="align-self-center">&nbsp; X &nbsp;</span>
                <Img
                    src={'/img/partners/ncsa/ncsa-logo.svg'}
                    className={`${styles.utrlogo} align-self-start`}
                />
            </div>
            <div className={`${styles.section} pt24`}>
                <div className={`mb24`}>
                    <p className="text-dark" data-testid="modal.ncsa.description">
                        UTR Sports has partnered with NCSA College
                        Recruiting to help student-athletes with the dream
                        of playing in college.
                    </p>
                    <ul className="text-dark" data-testid="modal.ncsa.features-list">
                        <li data-testid="modal.ncsa.feature-1">Get noticed by 3500 college tennis coaches</li>
                        <li data-testid="modal.ncsa.feature-2">Meet with an NCSA expert for a <b>free</b> recruiting assessment</li>
                        <li data-testid="modal.ncsa.feature-3">Receive a <b>free</b> personalized recruiting game plan</li>
                    </ul>
                </div>
                <div className="row jcc mt48">
                    <button
                        type="button"
                        className="btn btn-default btn-xl mr8 text-uppercase p0 pr24 pl24"
                        onClick={() => {
                            onCloseClick();
                        }}
                        data-testid="modal.ncsa.not-now-btn"
                    >
                        Not Now
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary btn-xl text-uppercase"
                        onClick={() => {
                            onConfirm();
                        }}
                        {...getClickAttrs({
                            category: 'NCSA',
                            context: `NCSA HomePage Popup Yes Click - Flow 28157`,
                            location: 'NCSA HomePage Popup',
                        })}
                        data-testid="modal.ncsa.confirm-btn"
                    >
                        Yes
                    </button>
                </div>
            </div>
        </Popup>
    );
};

export default NCSAPopup;
